import { api, ERR_OK } from './config';
import axios from 'axios';

/**
 * 获取证书列表
 * @param userId
 * @param pageIndex
 * @param status
 * @param stuPhone
 * @param receiveType
 * @param schoolId
 * @param insNo
 * @return {Promise<AxiosResponse<any>>}
 */
export async function getCertList(userId, pageIndex = 1, status, stuPhone = '', receiveType = '', schoolId, insNo = '') {
  return await axios.post(api.certListUrl, {
    userId,
    pageIndex,
    status,
    stuPhone,
    receiveType,
    schoolId,
    insNo,
  }).then((res) => {
    if (res.data.rspCode === ERR_OK) {
      return res.data;
    } else {
      return [];
    }
  });
}

/**
 * 获取证书详情
 * @param userId
 * @param certId
 * @return {Promise<AxiosResponse<any>>}
 */
export async function getCertDetail(userId, certId) {
  return await axios.post(api.certDetailUrl, {
    userId,
    certId,
  }).then((res) => {
    return res.data;
  });
}

/**
 * 证书卡片预打印
 * @param userId
 * @param certIds
 * @return {Promise<AxiosResponse<any>>}
 */
export async function certPrintPre(userId, certIds) {
  return await axios.post(api.printPreUrl, {
    userId,
    certIds,
  }).then((res) => {
    return res.data;
  });
}

/**
 * 证书预发货
 * @param userId
 * @param certIds
 * @return {Promise<AxiosResponse<any>>}
 */
export async function certExpressPre(userId, certIds) {
  return await axios.post(api.expressPreUrl, {
    userId,
    certIds,
  }).then((res) => {
    return res.data;
  });
}

/**
 * 证书发货
 * @param userId
 * @param certIds
 * @param expressCo
 * @param expressNo
 * @return {Promise<AxiosResponse<any>>}
 */
export async function certExpress(userId, certIds, expressCo, expressNo) {
  return await axios.post(api.expressUrl, {
    userId,
    certIds,
    expressCo,
    expressNo,
  }).then((res) => {
    return res.data;
  });
}